import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { cn } from '@/lib/utils';
import ResqlyCard from './ResqlyCard';

export default function ResqlyServiceCard({
  service,
  to,
  featured = false,
  compact = false,
  className,
}) {
  const Icon = Icons[service.icon] || Icons.Activity;
  const content = (
  <>
      <motion.div
        className={cn(
          'flex items-center justify-center rounded-2xl',
          compact ? 'h-11 w-11' : 'h-14 w-14',
        )}
        style={{ background: service.bg }}
        whileTap={{ scale: 0.94 }}
        transition={{ duration: 0.14 }}
      >
        <Icon size={compact ? 20 : 26} color={service.fg} strokeWidth={2.2} />
      </motion.div>
      <div className={cn('min-w-0', compact ? 'mt-2' : 'mt-3')}>
        <div className={cn('font-semibold text-slate-900', compact ? 'text-sm' : 'text-base')}>
          {service.label}
        </div>
        {service.hint && !compact && (
          <div className="text-xs text-slate-500 mt-0.5 line-clamp-2">{service.hint}</div>
        )}
      </div>
    </>
  );

  const cardClass = cn(
    'block p-4 transition-shadow hover:shadow-[var(--resqly-shadow-md)] active:scale-[0.98]',
    featured && 'ring-2 ring-blue-600/15 bg-gradient-to-br from-white to-blue-50/40',
    compact && 'p-3 flex flex-col items-center text-center',
    !compact && 'flex flex-col',
    className,
  );

  if (to) {
    return (
      <Link data-testid={`service-${service.key}`} to={to} className="group">
        <ResqlyCard className={cardClass} elevated>
          {content}
        </ResqlyCard>
      </Link>
    );
  }

  return (
    <ResqlyCard className={cardClass} elevated>
      {content}
    </ResqlyCard>
  );
}
